import { TabContainer, TabHeader, TabLabel, TabLogo, TabLogoBg } from './style';

interface Props {
  label: string;
  title: string;
  primaryColor: string;
  secondaryColor: string;
  logo: string;
  onClick: () => void;
}

const getHoverColor = (color: string) => {
  switch (color) {
    case '#007CFF': {
      return 'filter: brightness(0) saturate(100%) invert(53%) sepia(72%) saturate(6958%) hue-rotate(199deg) brightness(101%) contrast(106%);';
    }
    case '#A48D9F': {
      return 'filter: brightness(0) saturate(100%) invert(64%) sepia(4%) saturate(1322%) hue-rotate(261deg) brightness(90%) contrast(90%);';
    }
    case '#CCE3F2': {
      return 'filter: brightness(0) saturate(100%) invert(82%) sepia(25%) saturate(242%) hue-rotate(173deg) brightness(107%) contrast(90%);';
    }
    case '#FAF7F9': {
      return 'filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7472%) hue-rotate(26deg) brightness(104%) contrast(95%);';
    }
    case '#FFA800': {
      return 'filter: brightness(0) saturate(100%) invert(59%) sepia(95%) saturate(1093%) hue-rotate(359deg) brightness(102%) contrast(106%)';
    }
    case '#FFEECC': {
      return 'filter: brightness(0) saturate(100%) invert(88%) sepia(33%) saturate(254%) hue-rotate(337deg) brightness(103%) contrast(101%);';
    }

  }
}

export default function Tab({ label, title, logo, onClick, primaryColor, secondaryColor }: Props) {

  const hoverColor = getHoverColor(secondaryColor) || '';
  const primaryFilter = getHoverColor(primaryColor) || '';

  return <TabContainer
    hoverColor={secondaryColor}
    hoverFilter={hoverColor}
    primaryColor={primaryColor}
    primaryFilter={primaryFilter}
    onClick={onClick}
    className="cursor-pointer"
  >
    <TabLogoBg id="tab-logo-bg" className="mb-4"><TabLogo id="tab-logo" src={logo} alt={`${label} logo`} /></TabLogoBg>
    <div>
      <TabHeader className="mb-2">{title}<img id="tab-right" src="/tabArrow.svg" /></TabHeader>
      <TabLabel>{label}</TabLabel>
    </div>
  </TabContainer>;

}
